<template>
  <div class="critical-document-wrapper">
    <!-- PÁGINA 1 DE 4 -->
    <div class="page-sheet">
      <!-- Encabezado Oficial -->
      <table class="header-table">
        <tbody>
          <tr>
            <td class="header-logo-cell">
              <img src="/static/logo_sp.png" alt="Sunshine" class="company-logo" />
            </td>
            <td class="header-title-cell">
              <div class="main-title">ESTUDIO DE<br />SEGURIDAD PARA<br />EMPLEADOS</div>
            </td>
            <td class="header-meta-cell">
              <div><strong>CÓDIGO :</strong> SIG-ES-RH-FR-022</div>
              <div><strong>VERSIÓN :</strong> 06</div>
              <div><strong>Fecha de Creación :</strong> 01/01/2012</div>
              <div><strong>Ultima Revisión :</strong> 15/07/2025</div>
              <div><strong>Páginas :</strong> 1 de 4</div>
              <div><strong>Anexos :</strong> 00</div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Párrafo Generalidades -->
      <div class="section-notice mt-2">
        <strong>GENERALIDADES:</strong> La siguiente información es necesaria para el estudio de seguridad de la empresa. Los datos suministrados serán clasificados como información confidencial y podrán ser presentados ante las autoridades de control cuando estas así lo requieran. Toda información registrada en el presente formato será confirmada por funcionarios de la empresa.
      </div>

      <div class="d-flex justify-space-between align-center mt-2 mb-2 font-size-12">
        <div><strong>Fecha:</strong> {{ formattedDate }}</div>
        <div><strong>Código:</strong> {{ workerData.WkrCode || '..............' }}</div>
      </div>

      <!-- I. DATOS PERSONALES -->
      <div class="section-heading">I. DATOS PERSONALES</div>
      <div class="personal-data-fields">
        <div class="field-row">
          <span class="field-label">Nombres y Apellidos</span>
          <span class="field-dots">{{ workerData.NtpFullName || '' }}</span>
        </div>
        <div class="field-row-split">
          <div class="field-item">
            <span class="field-label">DNI N°</span>
            <span class="field-dots">{{ workerData.PrsDocumentNumber || '' }}</span>
          </div>
          <div class="field-item">
            <span class="field-label">Lugar de Expedición</span>
            <span class="field-dots">{{ workerData.ExpeditionPlace || '' }}</span>
          </div>
        </div>
        <div class="field-row-split">
          <div class="field-item">
            <span class="field-label">Fecha de Nacimiento</span>
            <span class="field-dots">{{ formattedBirthDate }}</span>
          </div>
          <div class="field-item">
            <span class="field-label">Ciudad</span>
            <span class="field-dots">{{ workerData.City || '' }}</span>
          </div>
          <div class="field-item">
            <span class="field-label">Provincia</span>
            <span class="field-dots">{{ workerData.Province || '' }}</span>
          </div>
        </div>
        <div class="field-row-split">
          <div class="field-item">
            <span class="field-label">País</span>
            <span class="field-dots">{{ workerData.Country || 'PERÚ' }}</span>
          </div>
          <div class="field-item">
            <span class="field-label">Brevete</span>
            <span class="field-dots">{{ workerData.License || '' }}</span>
          </div>
          <div class="field-item">
            <span class="field-label">ONP</span>
            <span class="field-dots">{{ isOnp ? 'SÍ' : '' }}</span>
          </div>
          <div class="field-item">
            <span class="field-label">AFP Afiliado</span>
            <span class="field-dots">{{ isAfp ? (workerData.PensionRegimeName || 'SÍ') : '' }}</span>
          </div>
        </div>
        <div class="field-row">
          <span class="field-label">Domiciliado en</span>
          <span class="field-dots">{{ workerData.Address || '' }}</span>
          <span class="field-suffix">(Adjunte croquis)</span>
        </div>
        <div class="civil-status-row">
          <span class="field-label mr-3">Estado Civil:</span>
          <span class="checkbox-box"><span class="box-mark">{{ isCivilStatus(1) ? 'X' : '' }}</span> Soltero</span>
          <span class="checkbox-box"><span class="box-mark">{{ isCivilStatus(2) ? 'X' : '' }}</span> Casado</span>
          <span class="checkbox-box"><span class="box-mark">{{ isCivilStatus(3) ? 'X' : '' }}</span> Conviviente</span>
          <span class="checkbox-box"><span class="box-mark">{{ isCivilStatus(4) ? 'X' : '' }}</span> Viudo</span>
          <span class="checkbox-box"><span class="box-mark">{{ isCivilStatus(5) ? 'X' : '' }}</span> Divorciado</span>
        </div>
      </div>

      <!-- II. DATOS FAMILIARES -->
      <div class="section-heading mt-3">II. DATOS FAMILIARES (Integrantes de la vivienda)</div>
      <table class="grid-table">
        <thead>
          <tr>
            <th style="width: 15%;">VINCULO</th>
            <th style="width: 32%;">APELLIDOS Y NOMBRES</th>
            <th style="width: 13%;">FECHA NAC.</th>
            <th style="width: 12%;">DNI</th>
            <th style="width: 14%;">OCUPACION</th>
            <th style="width: 14%;">DIRECCION</th>
          </tr>
        </thead>
        <tbody>
          <tr><td class="font-weight-bold">Padre</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td class="font-weight-bold">Madre</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td class="font-weight-bold">Esposa (o)</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td class="font-weight-bold">Hijos</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td class="font-weight-bold">&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td class="font-weight-bold">Hermanos</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td class="font-weight-bold">&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td class="font-weight-bold">&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td class="font-weight-bold">Tíos</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td class="font-weight-bold">&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
        </tbody>
      </table>

      <div class="emergency-contacts mt-3">
        <div class="emergency-line">
          <span>En caso de emergencia, llamar a : _______________________________________________</span>
          <span class="ml-4">Tel.: _______________________</span>
        </div>
        <div class="emergency-line mt-1">
          <span>O a: _________________________________________________________________________</span>
          <span class="ml-4">Tel.: _______________________</span>
        </div>
      </div>

      <div class="page-footer-note">
        Se prohíbe la reproducción total o parcial de este documento sin autorización del Representante BASC
      </div>
    </div>

    <!-- PÁGINA 2 DE 4 -->
    <div class="page-sheet">
      <table class="header-table">
        <tbody>
          <tr>
            <td class="header-logo-cell">
              <img src="/static/logo_sp.png" alt="Sunshine" class="company-logo" />
            </td>
            <td class="header-title-cell">
              <div class="main-title">ESTUDIO DE<br />SEGURIDAD PARA<br />EMPLEADOS</div>
            </td>
            <td class="header-meta-cell">
              <div><strong>CÓDIGO :</strong> SIG-ES-RH-FR-022</div>
              <div><strong>VERSIÓN :</strong> 06</div>
              <div><strong>Fecha de Creación :</strong> 01/01/2012</div>
              <div><strong>Ultima Revisión :</strong> 15/07/2025</div>
              <div><strong>Páginas :</strong> 2 de 4</div>
              <div><strong>Anexos :</strong> 00</div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- III. DATOS DE SALUD E INDICACIONES MEDICAS -->
      <div class="section-heading mt-3">III. DATOS DE SALUD E INDICACIONES MEDICAS</div>
      <div class="health-notice mt-2 mb-2 font-size-12">
        Indicar condiciones médicas de riesgo y por favor dar todas las indicaciones a tomar en cuenta para cualquier situación de emergencia:
        <div class="write-line mt-2"></div>
        <div class="write-line mt-2"></div>
        <div class="write-line mt-2"></div>
      </div>

      <!-- IV. ESTUDIOS DESARROLLADOS -->
      <div class="section-heading mt-3">IV. ESTUDIOS DESARROLLADOS</div>
      <table class="grid-table mt-2">
        <thead>
          <tr>
            <th style="width: 28%;">NIVEL</th>
            <th style="width: 44%;">INSTITUCION</th>
            <th style="width: 28%;">GRADO OBTENIDO</th>
          </tr>
        </thead>
        <tbody>
          <tr><td class="font-weight-bold">PRIMARIA</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td class="font-weight-bold">SECUNDARIA</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td class="font-weight-bold">UNIVERSIDAD</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td class="font-weight-bold">POST-GRADO</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td class="font-weight-bold">INSTITUTO</td><td>&nbsp;</td><td>&nbsp;</td></tr>
        </tbody>
      </table>

      <div class="sub-heading mt-2">Estudios Complementarios (De Perfeccionamiento, Etc…).</div>
      <table class="grid-table mt-1">
        <thead>
          <tr>
            <th style="width: 42%;">NOMBRE DEL CURSO</th>
            <th style="width: 38%;">INSTITUCION</th>
            <th style="width: 20%;">DURACION</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
        </tbody>
      </table>

      <div class="sub-heading mt-3">Conocimientos Especiales</div>
      <div class="font-size-12 mt-1">
        <div>Computación: Si ( &nbsp; ) No ( &nbsp; ) &nbsp;&nbsp;&nbsp; Softs: …………………………………………………………………………………</div>
        <div class="mt-1">Idiomas: ……………………….. Habla: ………………… Lee: ……………………. Escribe: ………………….</div>
        <div class="mt-1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;……………………….. Habla: ………………… Lee: ……………………. Escribe: ………………….</div>
      </div>

      <!-- V. EXPERIENCIA LABORAL -->
      <div class="section-heading mt-4">V. EXPERIENCIA LABORAL</div>
      <table class="grid-table mt-2">
        <thead>
          <tr>
            <th style="width: 25%;">EMPRESA</th>
            <th style="width: 22%;">CARGO</th>
            <th style="width: 20%;">TIEMPO</th>
            <th style="width: 18%;">JEFE INMEDIATO</th>
            <th style="width: 15%;">MOTIVO DE RETIRO</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>&nbsp;</td><td>&nbsp;</td><td class="text-center font-size-11">..…/.….. a ..…/…...</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td>&nbsp;</td><td>&nbsp;</td><td class="text-center font-size-11">..…/.….. a ..…/…...</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td>&nbsp;</td><td>&nbsp;</td><td class="text-center font-size-11">..…/.….. a ..…/…...</td><td>&nbsp;</td><td>&nbsp;</td></tr>
          <tr><td>&nbsp;</td><td>&nbsp;</td><td class="text-center font-size-11">..…/.….. a ..…/…...</td><td>&nbsp;</td><td>&nbsp;</td></tr>
        </tbody>
      </table>

      <div class="page-footer-note">
        Se prohíbe la reproducción total o parcial de este documento sin autorización del Representante BASC
      </div>
    </div>

    <!-- PÁGINA 3 DE 4 -->
    <div class="page-sheet">
      <table class="header-table">
        <tbody>
          <tr>
            <td class="header-logo-cell">
              <img src="/static/logo_sp.png" alt="Sunshine" class="company-logo" />
            </td>
            <td class="header-title-cell">
              <div class="main-title">ESTUDIO DE<br />SEGURIDAD PARA<br />EMPLEADOS</div>
            </td>
            <td class="header-meta-cell">
              <div><strong>CÓDIGO :</strong> SIG-ES-RH-FR-022</div>
              <div><strong>VERSIÓN :</strong> 06</div>
              <div><strong>Fecha de Creación :</strong> 01/01/2012</div>
              <div><strong>Ultima Revisión :</strong> 15/07/2025</div>
              <div><strong>Páginas :</strong> 3 de 4</div>
              <div><strong>Anexos :</strong> 00</div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- VI. ASPECTO ECONÓMICO -->
      <div class="section-heading mt-3">VI. ASPECTO ECONÓMICO</div>
      <div class="font-size-12 mt-2">
        <div class="font-weight-bold">Especifique en que están representados sus activos:</div>
        
        <div class="sub-heading mt-2">Vivienda</div>
        <div class="d-flex align-center flex-wrap mt-1">
          <span class="checkbox-box mr-3"><span class="box-mark"></span> Propia</span>
          <span class="checkbox-box mr-3"><span class="box-mark"></span> Familiar</span>
          <span class="checkbox-box mr-3"><span class="box-mark"></span> Alquilada</span>
          <span class="mr-3">Monto de alquiler: ……………..</span>
          <span>Otros ………………………….</span>
        </div>

        <div class="sub-heading mt-2">Vehículo</div>
        <div class="mt-1">Marca …………………… Modelo ………………… Placa ………………… Valor comercial ……………</div>
        <div class="mt-1">Título conductor (Brevete) …………………</div>
        <div class="mt-1">Otros (por ejemplo moto) ………………………………………………………………………………………</div>

        <div class="sub-heading mt-2">Cuenta bancaria que posee</div>
        <div class="d-flex justify-space-between mt-1">
          <span>Corriente N° ………………………………………</span>
          <span>Banco ………………………………………………</span>
        </div>
        <div class="d-flex justify-space-between mt-1">
          <span>Ahorros N° ………………………………………..</span>
          <span>Banco ………………………………………………</span>
        </div>
        <div class="d-flex justify-space-between mt-1">
          <span>Tarjeta de Crédito N° ……………………………</span>
          <span>Banco ………………………………………………</span>
        </div>

        <div class="sub-heading mt-2">Bienes muebles e inmuebles</div>
        <div class="mt-1">Describa ……………………………………………………………………………………………………........</div>
        <div class="mt-1">…………………………………………………………………………………………………………………….</div>
        <div class="mt-1">.……………………………………………………………………………………………………………………</div>

        <div class="d-flex justify-space-between mt-2">
          <span>Ingreso económico mensual ……………………………………</span>
          <span>Egresos mensuales ……………………</span>
        </div>
        <div class="d-flex justify-space-between mt-1">
          <span>Valor total de sus activos ………………………………...</span>
          <span>Valor total de sus deudas……………………...</span>
        </div>
      </div>

      <!-- VII. ASPECTO SOCIAL CULTURAL -->
      <div class="section-heading mt-4">VII. ASPECTO SOCIAL CULTURAL</div>
      <div class="font-size-12 mt-2">
        <div>Indique si es parte de una entidad (clubes, asociaciones culturales, políticas, sociales, etc…).</div>
        <div class="mt-1">…………………………………………………………………………………………………………………….</div>
        <div class="mt-1">Aficiones, deportes, etc. ……………………………………………………………………………………….</div>
        <div class="mt-1">Ciudades del país que conoce ………………………………………………………………………………..</div>
        <div class="mt-1">Países que ha visitado …………………………………………………………………………………………</div>

        <div class="mt-2 font-weight-bold">Valores importantes para usted (marque las 3 mas importantes)</div>
        <div class="values-grid mt-2">
          <div class="values-row">
            <span class="checkbox-box"><span class="box-mark"></span> Honestidad</span>
            <span class="checkbox-box"><span class="box-mark"></span> Lealtad</span>
            <span class="checkbox-box"><span class="box-mark"></span> Respeto</span>
            <span class="checkbox-box"><span class="box-mark"></span> Compañerismo</span>
          </div>
          <div class="values-row mt-2">
            <span class="checkbox-box"><span class="box-mark"></span> Amistad</span>
            <span class="checkbox-box"><span class="box-mark"></span> Puntualidad</span>
            <span class="checkbox-box"><span class="box-mark"></span> Orden</span>
            <span class="checkbox-box"><span class="box-mark"></span> Compromiso</span>
          </div>
          <div class="values-row mt-2">
            <span class="checkbox-box"><span class="box-mark"></span> Responsabilidad</span>
          </div>
        </div>
      </div>

      <div class="page-footer-note">
        Se prohíbe la reproducción total o parcial de este documento sin autorización del Representante BASC
      </div>
    </div>

    <!-- PÁGINA 4 DE 4 -->
    <div class="page-sheet">
      <table class="header-table">
        <tbody>
          <tr>
            <td class="header-logo-cell">
              <img src="/static/logo_sp.png" alt="Sunshine" class="company-logo" />
            </td>
            <td class="header-title-cell">
              <div class="main-title">ESTUDIO DE<br />SEGURIDAD PARA<br />EMPLEADOS</div>
            </td>
            <td class="header-meta-cell">
              <div><strong>CÓDIGO :</strong> SIG-ES-RH-FR-022</div>
              <div><strong>VERSIÓN :</strong> 06</div>
              <div><strong>Fecha de Creación :</strong> 01/01/2012</div>
              <div><strong>Ultima Revisión :</strong> 15/07/2025</div>
              <div><strong>Páginas :</strong> 4 de 4</div>
              <div><strong>Anexos :</strong> 00</div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="mt-3 font-size-12 text-justify line-height-14">
        <strong>Nota:</strong> Certifico que la información aquí suministrada es verdadera y podrá ser verificada en cualquier momento por la empresa. Así mismo estoy dispuesto a brindar una ampliación de cualquier aspecto de los datos registrados
      </div>

      <!-- 5 Recuadros de Huellas Digitales -->
      <div class="fingerprints-container mt-4">
        <div class="fingerprint-column">
          <div class="fingerprint-box"></div>
          <div class="fingerprint-label">Huella<br />Digital<br />Pulgar<br />Derecho</div>
        </div>
        <div class="fingerprint-column">
          <div class="fingerprint-box"></div>
          <div class="fingerprint-label">Huella<br />Digital<br />Índice<br />Derecho</div>
        </div>
        <div class="fingerprint-column">
          <div class="fingerprint-box"></div>
          <div class="fingerprint-label">Huella<br />Digital<br />Medio<br />Derecho</div>
        </div>
        <div class="fingerprint-column">
          <div class="fingerprint-box"></div>
          <div class="fingerprint-label">Huella<br />Digital<br />Anular<br />Derecho</div>
        </div>
        <div class="fingerprint-column">
          <div class="fingerprint-box"></div>
          <div class="fingerprint-label">Huella<br />Digital<br />Meñique<br />Derecho</div>
        </div>
      </div>

      <div class="mt-4 font-size-12">
        Adjunto Certificado Único Laboral (CUL), Declaración jurada de domicilio y fotocopia DNI.
      </div>

      <div class="signature-section-worker mt-4 font-size-12">
        <div>Firma ……………………………</div>
        <div class="mt-2">DNI <strong>{{ workerData.PrsDocumentNumber || '………………………………' }}</strong></div>
      </div>

      <hr class="divider-line mt-4 mb-3" />

      <!-- Recuadro Exclusivo de la Empresa -->
      <div class="exclusive-use-title">PARA USO EXCLUSIVO DE LA EMPRESA</div>
      <table class="company-eval-table mt-2">
        <tbody>
          <tr>
            <td class="eval-signature-cell">
              <div class="signature-line-company"></div>
              <div class="eval-signer-title">
                FIRMA DE RESPONSABLE DE<br />ADMINISTRACIÓN DE PERSONAL.
              </div>
            </td>
            <td class="eval-status-cell">
              <div>Fecha de verificación de datos: ………….</div>
              <div class="d-flex align-center mt-3">
                <span class="mr-4">Aprobado</span>
                <span class="checkbox-square"></span>
              </div>
              <div class="d-flex align-center mt-2">
                <span class="mr-1">No Aprobado</span>
                <span class="checkbox-square"></span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="page-footer-note mt-6">
        Se prohíbe la reproducción total o parcial de este documento sin autorización del Representante BASC
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CriticalEmployeeSecurityStudy",
  props: {
    workerData: {
      type: Object,
      default: () => ({}),
    },
    documentDate: {
      type: String,
      default: null,
    },
  },
  computed: {
    formattedDate() {
      const raw = this.documentDate || this.workerData.AgtBeginDate;
      if (raw) {
        const parts = String(raw).substring(0, 10).split("-");
        if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
      }
      const now = new Date();
      const dd = String(now.getDate()).padStart(2, "0");
      const mm = String(now.getMonth() + 1).padStart(2, "0");
      const yyyy = now.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    },
    formattedBirthDate() {
      const raw = this.workerData.PrsBirthDate;
      if (raw) {
        const parts = String(raw).substring(0, 10).split("-");
        if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
      }
      return "...../...../..........";
    },
    isOnp() {
      const name = (this.workerData.PensionRegimeName || "").toUpperCase();
      return name.includes("ONP");
    },
    isAfp() {
      const name = (this.workerData.PensionRegimeName || "").toUpperCase();
      return name.includes("AFP") || (!this.isOnp && !!this.workerData.PensionRegimeName);
    },
  },
  methods: {
    isCivilStatus(val) {
      return Number(this.workerData.TypeCivilStatus) === val;
    },
  },
};
</script>

<style scoped>
.critical-document-wrapper {
  font-family: Arial, sans-serif;
  color: #000;
  background: transparent;
}

.page-sheet {
  background: #ffffff;
  width: 100%;
  max-width: 760px;
  min-height: 1060px;
  margin: 0 auto 30px auto;
  padding: 30px 40px;
  border: 1px solid #dcdcdc;
  box-sizing: border-box;
  position: relative;
}

.header-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
}

.header-table td {
  border: 1px solid #000;
  vertical-align: middle;
  padding: 6px;
}

.header-logo-cell {
  width: 25%;
  text-align: center;
}

.company-logo {
  max-width: 125px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.header-title-cell {
  width: 45%;
  text-align: center;
}

.main-title {
  font-size: 13px;
  font-weight: bold;
  line-height: 1.25;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.header-meta-cell {
  width: 30%;
  font-size: 9px;
  line-height: 1.35;
  padding-left: 8px !important;
}

.section-notice {
  font-size: 10.5px;
  line-height: 1.35;
  text-align: justify;
}

.section-heading {
  font-size: 12px;
  font-weight: bold;
  text-decoration: underline;
  margin-top: 10px;
  margin-bottom: 6px;
  letter-spacing: 0.3px;
}

.sub-heading {
  font-size: 11.5px;
  font-weight: bold;
}

.font-size-11 {
  font-size: 11px;
}

.font-size-12 {
  font-size: 11.5px;
}

.line-height-14 {
  line-height: 1.4;
}

.field-row {
  display: flex;
  align-items: baseline;
  font-size: 11.5px;
  margin-bottom: 5px;
}

.field-row-split {
  display: flex;
  gap: 15px;
  align-items: baseline;
  font-size: 11.5px;
  margin-bottom: 5px;
}

.field-item {
  display: flex;
  flex: 1;
  align-items: baseline;
}

.field-label {
  font-weight: bold;
  white-space: nowrap;
  margin-right: 6px;
}

.field-dots {
  flex: 1;
  border-bottom: 1px dotted #000;
  min-height: 16px;
  padding: 0 4px;
}

.field-suffix {
  margin-left: 6px;
  white-space: nowrap;
  font-size: 10.5px;
}

.civil-status-row {
  display: flex;
  align-items: center;
  font-size: 11.5px;
  margin-top: 6px;
  margin-bottom: 6px;
}

.checkbox-box {
  display: inline-flex;
  align-items: center;
  margin-right: 14px;
  font-size: 11.5px;
}

.box-mark {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 1px solid #000;
  margin-right: 4px;
  text-align: center;
  line-height: 13px;
  font-size: 11px;
  font-weight: bold;
}

.checkbox-square {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 1px solid #000;
}

.grid-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 10.5px;
}

.grid-table th,
.grid-table td {
  border: 1px solid #000;
  padding: 4px 6px;
}

.grid-table th {
  background-color: #f7f7f7;
  font-weight: bold;
  text-align: center;
}

.grid-table td {
  height: 18px;
}

.emergency-line {
  font-size: 11px;
}

.write-line {
  border-bottom: 1px solid #000;
  height: 20px;
}

.values-grid {
  font-size: 11.5px;
}

.values-row {
  display: flex;
  justify-content: space-between;
}

.fingerprints-container {
  display: flex;
  justify-content: space-around;
  gap: 10px;
}

.fingerprint-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.fingerprint-box {
  width: 85px;
  height: 120px;
  border: 1px solid #000;
  background-color: #fff;
}

.fingerprint-label {
  font-size: 10px;
  text-align: center;
  margin-top: 6px;
  line-height: 1.2;
}

.signature-section-worker {
  margin-top: 20px;
}

.divider-line {
  border: none;
  border-top: 1px solid #000;
}

.exclusive-use-title {
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  letter-spacing: 0.5px;
}

.company-eval-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
}

.company-eval-table td {
  border: 1px solid #000;
  vertical-align: top;
  padding: 12px;
}

.eval-signature-cell {
  width: 50%;
  text-align: center;
}

.signature-line-company {
  width: 80%;
  margin: 40px auto 6px auto;
  border-bottom: 1px solid #000;
}

.eval-signer-title {
  font-size: 10.5px;
  font-weight: bold;
  line-height: 1.3;
}

.eval-status-cell {
  width: 50%;
  font-size: 11px;
}

.page-footer-note {
  font-size: 9.5px;
  font-style: italic;
  text-align: center;
  margin-top: 25px;
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
}

@media print {
  .page-sheet {
    page-break-after: always;
    break-after: page;
    border: none;
    box-shadow: none;
    margin: 0;
    padding: 10mm 15mm;
    min-height: 275mm;
  }
}
</style>
